import React from "react";
import "./footer.scss";
import logo from "../../asset/logo/logo gsc2.webp";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-citraland-surabaya"
          />
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Giantara Serpong City</h2>
          </div>
        </div>

        <div className="container-deskripsi">
          <h1>Get In Touch</h1>
          <p>Cisauk, Tangerang Regency, Banten</p>
          <div className="contact">Contact us : +6282114609687 (William)</div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">© 2024 All Rights Reserved.</div>
    </div>
  );
};

export default footer;
